import Model, { attr, belongsTo } from '@ember-data/model';
import type { AsyncBelongsTo } from '@ember-data/model';
import type CompanyModel from 'garaje/models/company';

export type ReuploadPolicy = 'never' | 'always' | 'after_days' | 'on_expiration' | 'on_date_yearly';

export interface ReUploadConfig {
  policy: ReuploadPolicy;
  days?: number; // for after_days
  month?: number; // for on_date_yearly (1-12)
  day?: number; // for on_date_yearly (1-31)
}

export default class CustomUserDocumentTemplateModel extends Model {
  @attr('string') declare title: string;
  @attr('string') declare description: string | undefined;
  @attr('boolean', { defaultValue: false }) declare parsingEnabled: boolean;
  @attr() declare reUploadConfig: ReUploadConfig | undefined;
  @attr('boolean', { defaultValue: false }) declare allowLlmParsing: boolean;

  @belongsTo('company', { async: true, inverse: null })
  declare company: AsyncBelongsTo<CompanyModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'custom-user-document-template': CustomUserDocumentTemplateModel;
  }
}
